import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";
import { t } from "@/lib/i18n";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white border border-gray-200 rounded-md p-10 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={48} weight="fill" className="text-gray-400 mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold text-gray-900 mb-2">{t("pay.cancelled", "Checkout cancelled")}</h1>
        <p className="text-sm text-gray-600 mb-6">No worries — you haven't been charged. Pick a plan whenever you're ready.</p>
        <button data-testid="cancel-back-to-pricing" onClick={() => navigate("/")}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md py-3 text-sm transition-colors">{t("pay.back_pricing", "Back to pricing")}</button>
      </div>
    </div>
  );
}
